import { Component, Input, OnInit } from '@angular/core';
import { AbstractService } from '@services/Abstract.service';
import {MyFile} from "@models/my-file";
import {Images} from "@constants/images";

@Component({
  selector: 'app-input-image',
  templateUrl: './input-image.component.html',
  styleUrls: ['./input-image.component.scss']
})
export class InputImageComponent implements OnInit {
  @Input() public service: AbstractService | null = null;
  @Input() label = '';
  @Input() cellType = '';
  @Input() name = '';
  @Input() required = false;
  @Input() multiple = false;
  filesImage: File[] = [];

  constructor(
      public images: Images
  ) { }

  ngOnInit(): void {
  }

  public onFilesAdded = (event: any) =>  {
    console.log(event);
    const files = event.hasOwnProperty('addedFiles') ? event.addedFiles : event.target.files;
    this.filesImage.push(...files);
    this.selectFiles(files, this.name);
  }

  public onRemoveMultiple = (event: any) => {
    this.filesImage.splice(this.filesImage.indexOf(event), 1);
    if (this.service !== null) {
      this.service.modelClass.model[this.name] = this.multiple ? [] : null;
    }
    if (this.multiple) {
      this.filesImage.map((item: any) => {
        if (this.service !== null) {
          this.service.modelClass.model[this.name] = [...this.service.modelClass.model[this.name], this.getImageBase64([item])];
        }
      });
    }
  }

  public selectFiles = (images: any, name: string) => {
    if (this.service !== null) {
      if (this.multiple) {
        if (!this.service.modelClass.model.hasOwnProperty(name) || this.service.modelClass.model[name] === null) {
          this.service.modelClass.model[name] = [];
        }
        images.map((item: any) => {
          if (this.service !== null) {
            this.service.modelClass.model[name] = [...this.service.modelClass.model[name], this.getImageBase64([item])];
          }
        });
      } else {
        this.service.modelClass.model[name] = this.getImageBase64(images);
      }
    }
  }

  /**
   * Obtiene los datos de la imagen y la codifica en base64
   */
  private getImageBase64 = (image: any) => {
    const imageBase64: MyFile = {
      height: 0,
      timestamp: new Date(),
      uri: '',
      fileName: '',
      data: ''
    };
    const file: File = image[0];
    const myDate = new Date();
    const myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      imageBase64.height = file.size;
      imageBase64.timestamp = new Date('2019-01-06T17:16:40');
      imageBase64.uri = file.name;
      imageBase64.fileName = file.name;
      const result = myReader.result ?? '';
      imageBase64.data = result.toString().split(',')[1] ?? '';
    };
    myReader.readAsDataURL(file);
    return imageBase64;
  }
}
